"use client"

import { useEffect } from "react" //use state and use effect are hooks
import Pusher from "pusher-js"
import BouncingBanner from "./BouncingBanner"
import { GiHorseHead } from "react-icons/gi"
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';

import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Grid,
  Card,
  BottomNavigation,
  BottomNavigationAction,
  Avatar,
} from "@mui/material"
import {
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  CalendarToday as CalendarTodayIcon,
  Payment as PaymentIcon,
  Menu as MenuIcon,
  Home as HomeIcon,
  Event as EventIcon,
  Description as DescriptionIcon,
} from "@mui/icons-material"
// import HorseIcon from '@mui/icons-material/Pets' // Horse-themed icon
import { useNavigate } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import ExitToAppIcon from "@mui/icons-material/ExitToApp"



const App = () => {
  const navigate = useNavigate()

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("CC_Token")
    localStorage.removeItem("user")
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    })
    setTimeout(() => navigate("/login"), 4000) // Redirect after toast
  }

  const handleNavigateToNotifications = () => {
    navigate("/notifications") // Redirige vers la page notifications
  }
  const handleProfile = () => {
    navigate("/Profile")
  }

  useEffect(() => {
    if (Notification.permission === "default") Notification.requestPermission()
    const pusher = new Pusher("aebc2eec94386d5d25a3", { cluster: "mt1", forceTLS: true })
  })

  return (
    <div className="app">
      {/* Toast Container */}
      <ToastContainer />

      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar alt="Logo" src={"../assets/cej.png"} sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      {/* Main Content */}
      <Box
        sx={{
          padding: "1rem",
          paddingTop: "70px", // Compensates for the fixed header
          paddingBottom: "70px", // Adds space for the fixed footer
          backgroundColor: "#f5f5f5",
        }}
      >
        {/* Image principale */}
        <Card
          sx={{
            marginBottom: "1rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="../assets/ja.jpg"
            alt="Club Équestre Jafoura"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "8px",
              maxWidth: "600px",
            }}
          />
        </Card>

        <BouncingBanner />
        {/* Menu Items */}
        <Grid container spacing={2}>
          {/* Emploi du temps */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/emploi")}
            >
              <CalendarTodayIcon sx={{ fontSize: 40, color: "#b8860b" }} />
              <Typography variant="h6" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Emploi du temps
              </Typography>
              <MenuIcon sx={{ fontSize: 30, color: "#b8860b" }} />
            </Card>
          </Grid>

          {/* Mes Séances */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/MesSeances")}
            >
              <EventIcon sx={{ fontSize: 40, color: "#b8860b" }} />
              <Typography variant="h6" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Mes Séances
              </Typography>
              <MenuIcon sx={{ fontSize: 30, color: "#b8860b" }} />
            </Card>
          </Grid>

          {/* Paiement */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/payment")}
            >
              <PaymentIcon sx={{ fontSize: 40, color: "#b8860b" }} />
              <Typography variant="h6" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Paiement
              </Typography>
              <MenuIcon sx={{ fontSize: 30, color: "#b8860b" }} />
            </Card>
          </Grid>

          {/* Détail Pension - Navigate to the separate page */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/DetailPension")}
            >
              <GiHorseHead style={{ fontSize: 40, color: "#b8860b" }} />
              <Typography variant="h6" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Détails Pension
              </Typography>
              <MenuIcon sx={{ fontSize: 30, color: "#b8860b" }} />
            </Card>
          </Grid>
  <Grid item xs={12}>
  <Card
      sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
              }}
    onClick={() => navigate("/suivichevaux")}
  >
    <MonitorWeightIcon style={{ fontSize: 40, color: "#b8860b" }} />
    <Typography variant="h1" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
      Suivi des chevaux
    </Typography>
    <MenuIcon sx={{ fontSize: 30, color: "#b8860b" }} />
  </Card>
</Grid>
          {/* Règlement intérieur */}
          <Grid item xs={12}>
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
              }}
              onClick={() => navigate("/Politique")}
            >
              <DescriptionIcon sx={{ fontSize: 40, color: "#b8860b" }} />
              <Typography variant="h6" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
                Règlement intérieur
              </Typography>
              <MenuIcon sx={{ fontSize: 30, color: "#b8860b" }} />
            </Card>
          </Grid>
         <Grid item xs={12}>
  <Card
    sx={{
      display: "flex",
      alignItems: "center",
      padding: "1rem",
      cursor: "pointer",
    }}
    onClick={() => navigate("/reservationBox")}
  >
    <EventIcon sx={{ fontSize: 40, color: "#b8860b" }} />
    <Typography variant="h6" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1 }}>
      Reservation Box
    </Typography>
    <MenuIcon sx={{ fontSize: 30, color: "#b8860b" }} />
  </Card>
</Grid>
        </Grid>
      </Box>

      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%", zIndex: 1000 }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/emploi")}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/home")}
          />
          <BottomNavigationAction
            label="Paiement"
            icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/payment")}
          />
        </BottomNavigation>
      </Box>
    </div>
  )
}

export default App
